const SET_PLAN_DATA = 'SET_PLAN_DATA';
const SET_CUSTOMIZED_PLAN_DATA = 'SET_CUSTOMIZED_PLAN_DATA';
const SET_DISPLAY_ADDING_PLAN_FORM = 'SET_DISPLAY_ADDING_PLAN_FORM';

export {
  SET_PLAN_DATA,
  SET_CUSTOMIZED_PLAN_DATA,
  SET_DISPLAY_ADDING_PLAN_FORM,
};
